import { EditLocation, Height } from "@mui/icons-material";
import { useDAppCommand } from "../../libs/dweb/DAppCommand";
import { DBasePage } from "../../libs/dweb/DBasePage";
import { DButton } from "../../libs/dweb/DButton";
import { DDialogSimple } from "../../libs/dweb/DDialogSimple";
import { DFormDialog } from "../../libs/dweb/DForm";
import { DPageHeader } from "../../libs/dweb/DPageHeader";
import { DRow } from "../../libs/dweb/DRow";
import { DTable } from "../../libs/dweb/DTable";
import { DText } from "../../libs/dweb/DText";
import { TAccountEntry, useMoney } from "../models/Hook";
import { DCol } from "../../libs/dweb/DCol";
import { dcolors } from "corexxx";
import { DRadioButton } from "../../libs/dweb/DRadioButton";
import { useState } from "react";
import { DInputString } from "../../libs/dweb/DInputString";
import { DSpace } from "../../libs/dweb/DSpace";
import { DSelectInput } from "../../libs/dweb/DSelectInput";
import { DTextDashboard } from "../../libs/dweb/DTextDashboard";
import { DTwoPaneView } from "../../libs/dweb/DTwoPaneView";
const week_options = [
  { text: "Monday", value: "mon" },
  { text: "Tuesday", value: "tue" },
  { text: "Wednesday", value: "wed" },
  { text: "Thursday", value: "thu" },
  { text: "Friday", value: "fri" },
  { text: "Saturday", value: "sat" },
  { text: "Sunday", value: "sun" },
];

type TPreviewType = {
  name: string;
  timestamp: string;
  amount: number; //+ or - based
};

type TFinalSummary = {
  total_income: number;
  total_expances: number;
  allItem: TPreviewType[];
  monthsDistribution: { [key: string]: TPreviewType[] };
};
type TType = "ONE_TIME" | "WEEKLY_RECURRING" | "MONTHLY_RECURRING";

// default
const defaultFinalSummary: TFinalSummary = {
  total_expances: 0,
  total_income: 0,
  monthsDistribution: {},
  allItem: [],
};

export function YearBudget() {
  let appComamnd = useDAppCommand();
  let moneyComamnd = useMoney();

  // Form
  let [type, setType] = useState<TType>("ONE_TIME");
  let [name, setName] = useState<string>("");
  let [amount, setAmount] = useState<string>("");
  let [time, setTime] = useState<string>("");

  // Preview
  const [previewList, setPreviewList] = useState<TPreviewType[]>([]);
  const [finalSummary, setFinalSummary] =
    useState<TFinalSummary>(defaultFinalSummary);

  const addToFinalSummary = () => {
    try {
      let result: TFinalSummary = {
        total_income: 0,
        total_expances: 0,
        allItem: [],
        monthsDistribution: {},
      };
      let allItem = [...finalSummary.allItem, ...previewList];
      //@ts-ignore
      const sortedData = allItem.sort(
        (a: any, b: any) =>
          new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime(),
      ) as TPreviewType[];
      sortedData.forEach((d) => {
        if (d.amount > 0) {
          result.total_income += d.amount;
        } else {
          result.total_expances += d.amount * -1;
        }
        result.allItem.push({
          name: d.name,
          timestamp: d.timestamp,
          amount: d.amount,
        });
      });
      setFinalSummary(result);
    } catch (e) { }
  };

  const buildList = (isIncome: boolean) => {
    let result: TPreviewType[] = [];
    switch (type) {
      case "ONE_TIME":
        result.push({
          name: name,
          amount: (isIncome ? 1 : -1) * parseFloat(amount),
          timestamp: convertToTimestamp(time),
        });
        break;
      case "MONTHLY_RECURRING": {
        let dates = generateMonthlyTimestamps(parseInt(time), 2025);
        dates.forEach((d) =>
          result.push({
            name: name,
            amount: (isIncome ? 1 : -1) * parseFloat(amount),
            timestamp: d,
          }),
        );
        break;
      }
      case "WEEKLY_RECURRING": {
        let dates = generateWeeklyTimestamps(time, 2025);
        dates.forEach((d) =>
          result.push({
            name: name,
            amount: (isIncome ? 1 : -1) * parseFloat(amount),
            timestamp: d,
          }),
        );
        break;
      }
    }
    setPreviewList(result);
  };

  return (
    <DBasePage
      style={{ padding: 0, height: "calc(100vh - 100px)" }}
      fullwidth={true}
    >
      <DTwoPaneView
        left={
          <DCol>
            <DRadioButton
              label="Expensen Type"
              onChange={(a) => setType(a as TType)}
              value={type}
              options={[
                { value: "ONE_TIME" },
                { value: "WEEKLY_RECURRING" },
                { value: "MONTHLY_RECURRING" },
              ]}
            />

            {type == "WEEKLY_RECURRING" ? (
              <DSelectInput
                label="Which day of Week?"
                value={time}
                onChange={setTime}
                options={week_options}
                style={{ width: "100%", marginBottom: 10 }}
              />
            ) : null}
            {type == "ONE_TIME" ? (
              <DInputString
                label="Time (DD/MM/YYYY)"
                onChange={setTime}
                value={time}
                style={{ width: "100%", marginBottom: 10 }}
              />
            ) : null}
            {type == "MONTHLY_RECURRING" ? (
              <DInputString
                label="Which Date of the Month?"
                onChange={setTime}
                value={time}
                style={{ width: "100%", marginBottom: 10 }}
              />
            ) : null}

            <DInputString
              label="Item Name"
              onChange={setName}
              value={name}
              style={{ width: "100%", marginBottom: 10 }}
            />
            <DInputString
              label="Amount"
              onChange={setAmount}
              value={amount}
              style={{ width: "100%", marginBottom: 10 }}
            />
            <DSpace />
            <DRow>
              <DButton
                text="Add as Expense"
                onClick={() => {
                  buildList(false);
                }}
              />
              <DSpace />
              <DButton
                text="Add as Income"
                onClick={() => {
                  buildList(true);
                }}
                style={{ background: "green" }}
              />
            </DRow>
            <DText style={{ marginTop: 20 }}>Preview</DText>
            <DTable
              height={300}
              data={previewList}
              columns={[
                {
                  field: "name",
                },
                {
                  field: "timestamp",
                  view_type: "datetime",
                },
                {
                  field: "amount",
                },
              ]}
            />
            <DRow style={{ marginTop: 10 }}>
              <DButton text="Add Preview" onClick={addToFinalSummary}></DButton>
              <DSpace />
              <DButton
                text="Remove Preview"
                onClick={() => {
                  setPreviewList([]);
                }}
              ></DButton>
            </DRow>
          </DCol>
        }
        right={
          <DCol id="print-area">
            <DCol>
              <DTextDashboard
                item={[
                  {
                    text: "Total Income",
                    value: finalSummary.total_income + "",
                  },
                  {
                    text: "Total Expences",
                    value: finalSummary.total_expances + "",
                    sub_text:
                      (
                        (finalSummary.total_expances /
                          (finalSummary.total_income || 1)) *
                        100
                      ).toFixed(2) + "% of Income",
                  },
                  {
                    text: "Total Saving",
                    value:
                      finalSummary.total_income -
                      finalSummary.total_expances +
                      "",
                    sub_text:
                      (
                        ((finalSummary.total_income -
                          finalSummary.total_expances) /
                          (finalSummary.total_income || 1)) *
                        100
                      ).toFixed(2) + "% of Income",
                  },
                ]}
              />
              <Table1 data={finalSummary.allItem} />
              <DRow style={{ marginTop: 10 }}>
                <DSpace />
                <DButton text="Print Report" onClick={printComponent} />
              </DRow>
            </DCol>
          </DCol>
        }
      />
    </DBasePage>
  );
}

function Table1({ data }: { data: any[] }) {
  console.log("Rendering table1");
  return (
    <DTable
      height={"100%"}
      data={data}
      columns={[
        {
          field: "name",
        },
        {
          field: "timestamp",
          view_type: "datetime",
        },
        {
          field: "amount",
          headerName: "Debit",
          format: (arg) => (arg > 0 ? arg : 0),
        },
        {
          field: "amount",
          headerName: "Credit",
          format: (arg) => (arg < 0 ? arg : 0),
        },
      ]}
    />
  );
}

function convertToTimestamp(dateString: string) {
  // Split the input string into day, month, and year
  const [day, month, year] = dateString.split("/").map(Number);

  // Create a new Date object (JavaScript months are 0-based, so subtract 1 from the month)
  const date = new Date(year, month - 1, day);

  // Return the ISO string representation of the date
  return date.toISOString();
}

// To generate timestamps for every month of a year based on a provided day (e.g., the 1st, 15th, or 31st), you need to handle cases where the specified day doesn't exist in some months (e.g., 31st in February or 30th in April).
function generateMonthlyTimestamps(day: number, year: number) {
  const timestamps = [];
  const monthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Check if it's a leap year
  const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  if (isLeapYear) monthDays[1] = 29; // Adjust February for leap years

  for (let month = 0; month < 12; month++) {
    if (day <= monthDays[month]) {
      const date = new Date(year, month, day);
      timestamps.push(date.toISOString());
    }
  }

  return timestamps;
}

function generateWeeklyTimestamps(dayOfWeek: string, year: number) {
  const dayNames = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  const dayIndex = dayNames.indexOf(dayOfWeek.toLowerCase());

  if (dayIndex === -1) {
    console.error("Invalid day of the week. Use 'sun', 'mon', 'tue', etc.");
    return [];
  }

  const timestamps = [];
  let currentDate = new Date(year, 0, 1); // Start on January 1st of the year

  // Find the first occurrence of the given day in the year
  while (currentDate.getDay() !== dayIndex) {
    currentDate.setDate(currentDate.getDate() + 1);
  }

  // Add all occurrences of the day to the list
  while (currentDate.getFullYear() === year) {
    timestamps.push(currentDate.toISOString());
    currentDate.setDate(currentDate.getDate() + 7); // Move to the next week
  }

  return timestamps;
}

const printComponent = () => {
  // Save the current page content

  const originalContents = document.body.innerHTML;

  // Replace the body content with the printable area
  // @ts-ignore
  const printContents = document.getElementById("print-area").innerHTML;
  document.body.innerHTML = printContents;

  // Trigger the print dialog
  window.print();

  // Restore the original content after printing or canceling
  //document.body.innerHTML = originalContents;
  console.log("Once you print, the page will be loaded again");
};
